import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { LaborView } from '../../features/operating-costs/labor-view';

export const Route = createFileRoute('/operating-costs/labor')({
  staticData: { breadcrumb: 'Labor' },
  component: LaborPage,
});
function LaborPage() {
  const enabled = useFeatureFlag('operating_costs');
  const partnerId = usePartnerId();
  return enabled ? (
    <LaborView partnerId={partnerId} />
  ) : (
    <div className="py-20 text-center">Operating costs are not enabled for your organisation.</div>
  );
}
